'use strict';

var scrollAnimate = require('base/components/scrollAnimate');

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for email sign-up
 * @param {Object} className - the class name of the element to append the message to
 */
function displayMessage(data, button, className) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    $(className).append('<div class="email-signup-alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.email-signup-alert').remove();
        button.removeAttr('disabled');
    }, 3000);
}

var SMS_PREFIX = '+(1) ';

/**
 * Formats raw digit string into prefixed US phone format
 * @param {string} digits - digit-only string up to 10 chars
 * @returns {string} formatted value with prefix e.g. "+(1) 555-867-5309"
 */
function formatSmsValue(digits) {
    var d = digits.slice(0, 10);
    var number = d;
    if (d.length > 6) {
        number = d.slice(0, 3) + '-' + d.slice(3, 6) + '-' + d.slice(6);
    } else if (d.length > 3) {
        number = d.slice(0, 3) + '-' + d.slice(3);
    }
    return SMS_PREFIX + number;
}

/**
 * Initialises SMS input with prefix lock and auto-dash formatting
 * @param {jQuery} el - jQuery-wrapped input element
 */
function initSmsInput(el) {
    el.on('focus', function () {
        if (this.value === '') {
            this.value = SMS_PREFIX;
        }
        var len = this.value.length;
        var input = this;
        setTimeout(function () { input.setSelectionRange(len, len); }, 0);
    });

    el.on('keydown', function (e) {
        var input = this;
        var cursorPos = input.selectionStart;

        if (e.key === 'Backspace' || e.key === 'Delete') {
            if (cursorPos <= SMS_PREFIX.length && input.selectionEnd <= SMS_PREFIX.length) {
                e.preventDefault();
            }
            return;
        }

        if (e.ctrlKey || e.metaKey) return;

        if (!/^\d$/.test(e.key)) {
            e.preventDefault();
        }
    });

    el.on('input', function () {
        var raw = this.value;
        if (raw.indexOf(SMS_PREFIX) !== 0) {
            raw = SMS_PREFIX;
        }
        var digits = raw.slice(SMS_PREFIX.length).replace(/\D/g, '');
        this.value = formatSmsValue(digits);
    });

    el.on('blur', function () {
        if (this.value === SMS_PREFIX) {
            this.value = '';
        }
    });
}

/**
 * Adds display none to the cookie preferences li in the footer if no anchor is present
 */
function hideTruevaultCookiePreferencesLi() {
    var $cookieLi = $('.footer-accordion__list li.cookie-preferences-wrapper');
    var $anchor = $cookieLi.find('a');

    if ($anchor.length === 0 || !$anchor.is(':visible')) {
        $cookieLi.hide();
    }
}

module.exports = function () {
    $('.back-to-top').click(function () {
        scrollAnimate();
    });

    setTimeout(function () {
        hideTruevaultCookiePreferencesLi();
    }, 3000);

    initSmsInput($('.js-sms-form-input'));

    $('.js-subscribe-sms').on('click', function (e) {
        e.preventDefault();
        var $button = $(this);
        var url = $button.data('href');
        var phone = $button.closest('form').find('.js-sms-form-input').val().replace(SMS_PREFIX, '');
        $.spinner().start();
        $(this).attr('disabled', true);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                phone: phone.trim()
            },
            success: function success(data) {
                displayMessage(data, $button, '.sms-signup-message');
                if (!data.error) {
                    $button.closest('form').find('.js-sms-form-input').val('');
                }
            },
            error: function error(err) {
                displayMessage(err, $button, '.sms-signup-message');
            }
        });
    });

    $('.js-subscribe-email').on('click', function (e) {
        e.preventDefault();
        const $button = $(this);
        const url = $button.data('href');
        const emailId = $button.closest('form').find('.js-hp-email-sign-up').val();
        $.spinner().start();
        $(this).attr('disabled', true);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                emailId: emailId.trim()
            },
            success: function (data) {
                displayMessage(data, $button, '.email-signup-message');
            },
            error: function (err) {
                displayMessage(err, $button, '.email-signup-message');
            }
        });
    });
};
